import Vue from 'vue'

export default {
  invoiceStates (params, query) {
    return Vue.axios.get(`/invoices/states?q=${query}`)
  },

  invoiceTitles (params, query) {
    return Vue.axios.get(`/invoices/titles?q=${query}`)
  },

  paymentSenders (params, query) {
    return Vue.axios.get(`/reports/payment/senders?q=${query}`)
  },

  paymentReceivers (params, query) {
    return Vue.axios.get(`/reports/payment/receivers?q=${query}`)
  },

  paymentPaymentReceivers (params, query) {
    return Vue.axios.get(`/reports/payment/paymentreceivers?q=${query}`)
  },

  paymentTitles (params, query) {
    return Vue.axios.get(`/reports/payment/titles?q=${query}`)
  },

  shipmentReceiveDocuments (params, query) {
    return Vue.axios.get(`/reports/shipment/receivedocuments?q=${query}`)
  },

  shipmentShipments (params, query) {
    return Vue.axios.get(`/reports/shipment/shipments?q=${query}`)
  },

  shipmentSender (params, query) {
    return Vue.axios.get(`/reports/shipment/senders?q=${query}`)
  },

  shipmentReceivers (params, query) {
    return Vue.axios.get(`/reports/shipment/receivers?q=${query}`)
  },

  shipmentPayers (params, query) {
    return Vue.axios.get(`/reports/shipment/payers?q=${query}`)
  },

  saleSenders (params, query) {
    return Vue.axios.get(`/reports/sale/senders?q=${query}`)
  },

  saleReceivers (params, query) {
    return Vue.axios.get(`/reports/sale/receivers?q=${query}`)
  },

  salePayer (params, query) {
    return Vue.axios.get(`/reports/sale/payers?q=${query}`)
  },

  saleNewReceiver (params, query) {
    return Vue.axios.get(`reports/sale/newreceivers?q=${query}`)
  },

  attachmentDocumentsTypes (params, query) {
    return Vue.axios.get(`/attachmentdocuments/types?q=${query}`)
  },

  attachmentDocumentsStates (params, query) {
    return Vue.axios.get(`/attachmentdocuments/states?q=${query}`)
  },

  releaseDocumentsStates () {
    return Vue.axios.get(`releasedocuments/states`)
  },
  releaseDocumentsNumbers (params,query) {
    return Vue.axios.get(`releasedocuments/releasenumbers?q=${query}`)
  },

  releaseDocumentsInvoices (params,query) {
    return Vue.axios.get(`releasedocuments/releaseinvoices?q=${query}`)
  },
  releaseDocumentsSenders (params, query) {
    return Vue.axios.get(`releasedocuments/senders?q=${query}`)
  },

  releaseDocumentsPayers (params, query) {
    return Vue.axios.get(`releasedocuments/payers?q=${query}`)
  },

  releaseDocumentsReceivers (params, query) {
    return Vue.axios.get(`releasedocuments/receivers?q=${query}`)
  },
  releaseDocumentsTransports (params, query) {
    return Vue.axios.get(`releasedocuments/transports?q=${query}`)
  },
  releaseDocumentsNewReceivers (params, query) {
    return Vue.axios.get(`releasedocuments/newreceivers?q=${query}`)
  },

  releaseDocumentsShipmentUnits (params, query) {
    if(params!==undefined){

           

            const searchParams = new URLSearchParams();        
            Object.keys(params).forEach(key => searchParams.append(key, params[key]));

      return Vue.axios.get(`/releasedocuments/shipmentunits?${searchParams.toString()}`)
    }
    return Vue.axios.get(`/releasedocuments/shipmentunits?q=${query}`)
  },

  shippingDocumentsCarriers (params, query) {
    return Vue.axios.get(`/shippingdocuments/carriers?q=${query}`)
  },

  shippingDocumentsSenders (params, query) {
    return Vue.axios.get(`/shippingdocuments/senders?q=${query}`)
  },

  shippingDocumentsReceivers (params, query) {
    return Vue.axios.get(`/shippingdocuments/receivers?q=${query}`)
  },

  shippingDocumentsStates () {
    return Vue.axios.get(`/shippingdocuments/states`)
  },

  shippingDocumentsTransportReveivers (params, query) {
    return Vue.axios.get(`/shippingdocuments/receivers?q=${query}`)
  },

  shippingDocumentsShipmentUnits (params, query) {
    return Vue.axios.get(`/shippingdocuments/shipmentunits?q=${query}`)
  },

  shipmentsDocumentsTransports (params, query) {
    return Vue.axios.get(`/shipments/transports?q=${query}`)
  },

  shipmentsDocumentsMarks (params, query) {
    return Vue.axios.get(`/shipments/marks?q=${query}`)
  },
  shipmentsDocumentsLots (params, query) {
    return Vue.axios.get(`/shipments/lots?q=${query}`)
  },

  shipmentsDocumentsDocuments (params, query) {
    return Vue.axios.get(`/shipments/receivedocuments?q=${query}`)
  },

  shipmentsDocumentsShipments (params, query) {
    return Vue.axios.get(`/shipments/shipments?q=${query}`)
  },
  
  shipmentsDocumentsSenders (params, query) {
    return Vue.axios.get(`/shipments/senders?q=${query}`)
  },

  shipmentsDocumentsReceivers (params, query) {
    return Vue.axios.get(`/shipments/receivers?q=${query}`)
  },

  shipmentsDocumentsStates (params, query) {
    return Vue.axios.get(`/shipments/states?q=${query}`)
  }
}
